const OWNER_STORAGE_KEY = "cm_owner";

export function getOwnerId() {
  try {
    return window.localStorage.getItem(OWNER_STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function setOwnerId(id) {
  if (!id) return;
  try {
    window.localStorage.setItem(OWNER_STORAGE_KEY, id);
  } catch {
    /* ignore quota / private mode */
  }
}

export function ownerHeaders() {
  const ownerId = getOwnerId();
  return ownerId ? { "X-Owner-Id": ownerId } : {};
}
